import axios from "axios";
import intl from "react-intl-universal";
import { message, Modal } from "antd";
import { getEnv } from "@/utils";
import { Cookie } from "@/utils/cookie";

let hasPermissionModalShown = false;

const apiHost = {
  dev: "http://192.168.2.209:8010/",
  // dev: "https://test.seller.9five.ai/api",
  test: "https://test.seller.9five.ai/api",
  uat: "https://test.seller.9five.ai/api",
  prod: "https://seller.9five.ai/api",
};

const url =
  process.env.NODE_ENV === "development" ? apiHost.dev : apiHost[getEnv()];

const http = axios.create({
  baseURL: url,
  timeout: 30 * 1000,
  // withCredentials: true,
  headers: {
    "Content-Type": "application/json; charset=utf-8",
    Authorization: `Bearer ${Cookie.get("token")}`,
    lang: localStorage.getItem("lang") || "zh_CN",
  },
});

// Add a request interceptor
http.interceptors.request.use(
  (config) => {
    return {
      ...config,
      headers: {
        ...config.headers,
        Authorization: `Bearer ${Cookie.get("token")}`,
        lang: localStorage.getItem("lang") || "zh_CN",
      },
    };
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Add a response interceptor
http.interceptors.response.use(
  (response) => {
    // console.log("response", response);
    if (response.status === 401 || response.data.code === 401) {
      document.cookie = "token= ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
      Modal.error({
        title: intl.get("common_http_401_title"),
        content: intl.get("common_http_401_desc"),
        keyboard: false,
        onOk: () => {
          window.location.href = "/login";
        },
      });
      return;
    }
    if (response.data.code === 422 && response.data.subCode === 422104) {
      Modal.confirm({
        title: intl.get("common_http_title"),
        content: response.data.message,
        keyboard: false,
        centered: true,
        cancelText: intl.get("common_http_cancle"),
        maskClosable: true,
        onOk: () => {
          window.location.href = "/shopList";
        },
        onCancel: () => {
          Modal.destroyAll();
        },
      });
      return "";
    }
    if (response.data.code === 403) {
      if (!hasPermissionModalShown) {
        hasPermissionModalShown = true;
        Modal.confirm({
          title: intl.get("common_http_title"),
          content: intl.get("common_http_403_desc"),
          keyboard: false,
          centered: true,
          cancelText: intl.get("common_http_cancle"),
          maskClosable: true,
          onOk: () => {
            window.location.href = "/package";
          },
          onCancel: () => {
            Modal.destroyAll();
          },
        });
        return "";
      } else {
        // ${response.data.message || intl.get("common_http_error")},
        message.error(`${intl.get("common_http_403_desc")}`);
        return "";
      }
    }

    if (response.data.code !== 200) {
      const msg = response.data.message;
      if (typeof msg === "string") {
        if (response.data.code === 423) {
          message.warning(msg);
        } else {
          message.error(response.data.message || intl.get("common_http_error"));
        }
      }
      // return Promise.reject(response.data);
    }

    return response.data;
  },
  (error) => {
    console.log("error", error, error.response);
    if (
      error.response &&
      (error.response?.status === 401 ||
        error.response?.request?.status === 401)
    ) {
      document.cookie = "token= ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
      window.location.href = "/login";
    } else {
      message.error(intl.get("common_http_error"));
    }
    return Promise.reject(error);
  },
);

export default http;
